import { BlockNoteDocument } from '../schema';
import isEmptyParagraph from './is-empty-paragraph';
import isImageOrTableBlock from './is-image-or-table-block';
import stripTrailingEmptyParagraphs from './strip-trailing-empty-paragraphs';

export default function shouldSyncParentIntoEditor(
  editorBlocks: BlockNoteDocument,
  parentBlocks: BlockNoteDocument | undefined,
) {
  if (!parentBlocks?.length) {
    return false;
  }

  const editorCleaned = stripTrailingEmptyParagraphs([...editorBlocks]);
  const parentCleaned = stripTrailingEmptyParagraphs([...parentBlocks]);

  if (JSON.stringify(editorCleaned) === JSON.stringify(parentCleaned)) {
    return false;
  }

  if (
    isEditorAheadByEmptyParagraphAfterImageOrTable(editorCleaned, parentCleaned)
  ) {
    return false;
  }

  return true;
}

function isEditorAheadByEmptyParagraphAfterImageOrTable(
  editorCleaned: BlockNoteDocument,
  parentCleaned: BlockNoteDocument,
) {
  if (editorCleaned.length !== parentCleaned.length + 1) {
    return false;
  }

  for (let index = 0; index < editorCleaned.length - 1; index++) {
    const block = editorCleaned[index];
    const nextBlock = editorCleaned[index + 1];

    if (!block || !isImageOrTableBlock(block) || !isEmptyParagraph(nextBlock)) {
      continue;
    }

    const editorWithoutInsertedLine = [
      ...editorCleaned.slice(0, index + 1),
      ...editorCleaned.slice(index + 2),
    ];

    if (
      JSON.stringify(editorWithoutInsertedLine) ===
      JSON.stringify(parentCleaned)
    ) {
      return true;
    }
  }

  return false;
}
